import BillingDetailCard from "./billingDetailCard.container";

export default BillingDetailCard;
